<template>
  <div>
    <b-table
        :data="clientes"
        :paginated=true
        per-page=10
        striped
        hoverable
        :current-page="currentPage"
        :pagination-simple=false
        pagination-position="bottom"
        default-sort-direction="desc"
        sort-icon="arrow-up"
        sort-icon-size="is-small"
        default-sort="publication.publication_date"
        aria-next-label="Siguiente"
        aria-previous-label="Anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
        >


        <b-table-column
          field= 'partner_entity'
          label= 'Nombre'
          searchable
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>
        <template v-slot="props">
          {{ props.row.partner_entity }}
        </template>
      </b-table-column>


      <b-table-column
          field= 'code'
          label= 'Código'
          searchable
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>
        <template v-slot="props">
            {{ props.row.code}}
        </template>
      </b-table-column>
      

      <b-table-column
          field= 'name'
          label= 'Nombre Servicio'
          searchable
          sortable>
        <template
            slot="searchable"
            slot-scope="props">
          <b-input
              v-model="props.filters[props.column.field]"
              icon="search"
              size="is-small" />
        </template>


        <template v-slot="props">
            {{ props.row.name}}
        </template>
      </b-table-column>
      <b-table-column
          field= 'start_date'
          label= 'Fecha inicio'
          sortable>
        <template v-slot="props">
          {{ props.row.start_date._isValid ? new Date(props.row.start_date).toLocaleDateString("es-CL"): '---' }}
        </template>
      </b-table-column>
      <b-table-column
          field= 'end_date'
          label= 'Fecha término'
          sortable>
        <template v-slot="props">
          {{ props.row.end_date._isValid  ? new Date(props.row.end_date).toLocaleDateString("es-CL"): '---' }}
        </template>
      </b-table-column>
      <b-table-column
          label="Acciones"
          width="10em"
          v-slot="props">
        <b-button type="is-primary"
                      icon-left="eye"
                      @click="goService(props.row)">
            </b-button>  
        <!--<b-icon
            pack="fas"
            icon="trash"
            size="is-medium"
            type="is-danger"
            @click.native="execNullifyModal(props.row.id, props.row)"/>
          -->
      </b-table-column>

      <template slot="empty" slot-scope="props">
        <div class="columns is-centered">
          <div class="column is-6 is-centered has-text-centered">
            <b-message type="is-danger">
              No se encontraron resultados para el año seleccionado.
            </b-message>
          </div>
        </div>
      </template>


    </b-table>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>

  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  props:[
    'objectId','componentType','cargoPrincipal', 'currentYear', 'minYear','maxYear', 'changeFilter', 'hideUpdate'
  ],
  data(){
    return{
      clientes:[],
      isLoading:false,
      currentPage:1,
      year: new Date().getFullYear(),
    }
  },
  components:{
  },
  created(){
    this.getCustomers();
  },
  methods:{
    goService(service){
      window.location.href = "/sdt_services/"+service.id+"?type="+service.table;
    },
    formatDate(date){
      if (date!=null && date!=="" && date!==undefined){
        var arreglo = date.split("-")
        return arreglo[2]+"-"+arreglo[1]+"-"+arreglo[0]
      }
      else{
        return ""
      }
    },
    getCustomers(){
      let vm = this;
      vm.isLoading=true;
      axios
        .get("/sdt_services/"+vm.objectId+"/customers.json",{params:{
            minYear: vm.minYear,
            maxYear: vm.maxYear,
            componentType: vm.componentType,
        }})
        .then(res => {
          
          vm.clientes = res.data;
          vm.clientes = vm.clientes.map(servicio => {
            var newServicio = servicio
            newServicio["start_date"] = moment(servicio.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"]);
            newServicio["end_date"] = moment(servicio.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"]);

            return newServicio;
          });
          vm.isLoading=false;
        })
        .catch(e => {
          console.log(e);
          vm.isLoading=false;
        });
    }
  },
  computed:{

  },
  watch:{
    changeFilter: function(){
      this.getCustomers()
    }
  }
}
</script>